/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface VehicleModelReferenceDto
 */
export interface VehicleModelReferenceDto {
    /**
     *
     * @type {number}
     * @memberof VehicleModelReferenceDto
     */
    vehicleModelReferenceId?: number;
    /**
     *
     * @type {string}
     * @memberof VehicleModelReferenceDto
     */
    make?: string;
    /**
     *
     * @type {string}
     * @memberof VehicleModelReferenceDto
     */
    model?: string;
    /**
     *
     * @type {string}
     * @memberof VehicleModelReferenceDto
     */
    vehicleType?: VehicleModelReferenceDtoVehicleTypeEnum;
    /**
     *
     * @type {number}
     * @memberof VehicleModelReferenceDto
     */
    batteryCapacityKwh?: number;
    /**
     *
     * @type {Date}
     * @memberof VehicleModelReferenceDto
     */
    createdAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof VehicleModelReferenceDto
     */
    updatedAt?: Date;
}

/**
 * @export
 */
export const VehicleModelReferenceDtoVehicleTypeEnum = {
    Unknown: "Unknown",
    Bev: "BEV",
    Phev: "PHEV",
    Fcev: "FCEV",
} as const;
export type VehicleModelReferenceDtoVehicleTypeEnum =
    (typeof VehicleModelReferenceDtoVehicleTypeEnum)[keyof typeof VehicleModelReferenceDtoVehicleTypeEnum];

/**
 * Check if a given object implements the VehicleModelReferenceDto interface.
 */
export function instanceOfVehicleModelReferenceDto(
    value: object,
): value is VehicleModelReferenceDto {
    return true;
}

export function VehicleModelReferenceDtoFromJSON(
    json: any,
): VehicleModelReferenceDto {
    return VehicleModelReferenceDtoFromJSONTyped(json, false);
}

export function VehicleModelReferenceDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): VehicleModelReferenceDto {
    if (json == null) {
        return json;
    }
    return {
        vehicleModelReferenceId:
            json["vehicleModelReferenceId"] == null
                ? undefined
                : json["vehicleModelReferenceId"],
        make: json["make"] == null ? undefined : json["make"],
        model: json["model"] == null ? undefined : json["model"],
        vehicleType:
            json["vehicleType"] == null ? undefined : json["vehicleType"],
        batteryCapacityKwh:
            json["batteryCapacityKwh"] == null
                ? undefined
                : json["batteryCapacityKwh"],
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        updatedAt:
            json["updatedAt"] == null ? undefined : new Date(json["updatedAt"]),
    };
}

export function VehicleModelReferenceDtoToJSON(
    value?: VehicleModelReferenceDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        vehicleModelReferenceId: value["vehicleModelReferenceId"],
        make: value["make"],
        model: value["model"],
        vehicleType: value["vehicleType"],
        batteryCapacityKwh: value["batteryCapacityKwh"],
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        updatedAt:
            value["updatedAt"] == null
                ? undefined
                : value["updatedAt"].toISOString(),
    };
}
